import * as types from '../../lib/actionTypes.es6';
import { take, call, put } from 'redux-saga/effects';
import { getRiskConfigs, getRiskConfigRaw, publishRiskConfig, createRiskConfig } from '../../lib/requests.es6';
import * as actions from './actions.es6';
import { unAuthorizedNotification } from '../../lib/access.es6';
import { GAloggerException } from '../../lib/monitoring.es6';

export function* getRiskConfigsWatcher() {
  while (true) {
    const { payload: partner } = yield take(types.GET_RISK_CONFIGS_REQUEST);
    try {
      const response = yield call(getRiskConfigs, partner);
      yield put(actions.getRiskConfigsSuccess(response.data.data));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.getRiskConfigsFail(e.response ? e.response.data : {}));
    }
  }
}

export function* getRiskConfigRawWatcher() {
  while (true) {
    const { payload: { partner } } = yield take(types.GET_RISK_CONFIG_RAW_REQUEST);
    try {
      const response = yield call(getRiskConfigRaw, partner);
      yield put(actions.getRiskConfigRawSuccess(response.data.data.yaml));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.getRiskConfigRawFail(e.response ? e.response.data : {}));
    }
  }
}

export function* publishRiskConfigWatcher() {
  while (true) {
    const { payload: { partner, rawYaml } } = yield take(types.PUBLISH_RISK_CONFIG_REQUEST);
    try {
      const response = yield call(publishRiskConfig, partner, rawYaml);
      yield put(actions.publishRiskConfigSuccess(response.data));
      yield put(actions.getRiskConfigsRequest(partner));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.publishRiskConfigFail(e.response ? e.response.data : {}));
    }
  }
}

export function* createRiskConfigWatcher() {
  while (true) {
    const { payload: { partner, rawYaml } } = yield take(types.CREATE_RISK_CONFIG_REQUEST);
    try {
      const response = yield call(createRiskConfig, partner, rawYaml);
      yield put(actions.createRiskConfigSuccess(response.data));
      yield put(actions.getRiskConfigsRequest(partner));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.createRiskConfigFail(e.response ? e.response.data : {}));
    }
  }
}
